import { QueryClient } from '@tanstack/react-query'
import { getDocumentData } from '.'

export const getFormDocumentQueryKey = (recipientId?: string) => ['document', recipientId]

export const formDocumentQuery = (id?: string) => ({
  queryKey: getFormDocumentQueryKey(id),
  queryFn: async () => getDocumentData(id),
})

export const formDocumentLoader =
  (queryClient: QueryClient) =>
  async ({ params }: any) => {
    const query = formDocumentQuery(params.recipientId)

    return queryClient.getQueryData(query.queryKey) || (await queryClient.fetchQuery(query))
  }
